import { apiSlice } from '../app/api/apiSlice';

export const documentsApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    getDocuments: builder.query({
      query: ()=> 'documents',
      method: 'GET',
    }),

    getDocumentsSignUp: builder.query({
      query: ()=> 'documents/documentsSignUp',
      method: 'GET',
    }),
    GetDocumentsInTermsAndConditions: builder.query({
      query: ()=> 'documents/GetDocumentsInTermsAndConditions',
      method: 'GET',
    }),
    getDocumentForUser: builder.query({
      query: (userId)=> ({
        url: `documents/documentsForUser/${userId}`,
        method: 'GET',
        keepUnusedDataFor: 0,
        providesTags: (result, error, arg)=>[
          {type:'document', id: 'LIST'},
      ]})
    }),
    documentAcceptance: builder.mutation({
      query: (acceptanceArray) => ({
        url: `Documents/documentsAcceptance`,
        method: 'POST',
        body: acceptanceArray,
      })
    }),    
    termsAndConditions: builder.query({
      query: ()=> 'documents/termsAndConditions',
      keepUnusedDataFor: 0,
      providesTags: (result, error, arg)=>[
        {type:'termsAndConditions', id: 'LIST'},
      ]
    }),
    acceptanceHistory: builder.query({
      query: (userId)=> 'documents/documentsAcceptance?userId=' + userId,
      keepUnusedDataFor: 0,
      providesTags: (result, error, arg)=>[
        {type:'documentsAcceptance', id: 'LIST'},
      ]
    })
  })
})

export const {
  useGetDocumentsQuery,
  useGetDocumentsSignUpQuery,
  useGetDocumentForUserQuery,
  useDocumentAcceptanceMutation,
  useTermsAndConditionsQuery,
  useAcceptanceHistoryQuery,
  useGetDocumentsInTermsAndConditionsQuery
} = documentsApi;